import { analytics } from './analytics'
import { ReportEvents } from './events'

export type ReportFiltersSource = 'panel' | 'chart'

export function trackReportViewed(report: string): void {
  analytics.track(ReportEvents.VIEWED, { report })
}

export function trackReportFiltersCleared(report: string): void {
  analytics.track(ReportEvents.FILTERS_CLEARED, { report })
}

export function trackReportRefreshed(report: string): void {
  analytics.track(ReportEvents.REFRESHED, { report })
}

export function trackReportAutoRefreshChanged(
  report: string,
  intervalSeconds: number,
): void {
  analytics.track(ReportEvents.AUTO_REFRESH_CHANGED, {
    report,
    interval_seconds: intervalSeconds,
  })
}
